import LocalizedStrings from 'localized-strings';

interface NewInternationalTransferRecipientLocale {
  failedToCreateRecipient: string;
  forcedUpdateCallout: {
    title: string;
    body: string;
  };
  submit: {
    new: string;
    edit: string;
  };
  title: string;
}

export default new LocalizedStrings<NewInternationalTransferRecipientLocale>({
  en: {
    failedToCreateRecipient: 'An error occurred',
    forcedUpdateCallout: {
      body: "Following a change in regulations, we ask you to fill in your beneficiary's details again.",
      title: 'Update details',
    },
    submit: {
      edit: 'Save changes',
      new: 'Add this beneficiary',
    },
    title: "Beneficiary's details",
  },
  fr: {
    failedToCreateRecipient: 'An error occurred',
    forcedUpdateCallout: {
      body: 'Suite à un changement de réglementation, nous vous demandons de remplir à nouveau les informations de votre bénéficiaire.',
      title: 'Informations à mettre à jour',
    },
    submit: {
      edit: 'Enregistrer',
      new: 'Ajouter ce bénéficiaire',
    },
    title: 'Coordonnées du bénéficiaire',
  },
} as const);
